// extracted by mini-css-extract-plugin
export default {"associate_section":"Technologies_associate_section__sPFIn","asscoiate_logo_wrapper":"Technologies_asscoiate_logo_wrapper__uzNNq"};